import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitConfigurationSubmissionData } from '../../../../../../models/submissions/variable-benefit-configuration-submission-data';
import { VariableBenefitDestinationJurisdictionDetail } from '../../../../../../models/submissions/variable-benefit-destination-jurisdiction-detail';

interface LumpSumRow {
  jurisdictionName: string;
  amount: number;
}

@Component({
  selector: 'app-vb-config-lump-sum-review-card',
  templateUrl: './vb-config-lump-sum-review-card.component.html',
  styleUrls: ['./vb-config-lump-sum-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigLumpSumReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitConfigurationSubmissionData;

  public hasLumpSum = false;
  public rows: LumpSumRow[] = [];
  public total = 0;
  public paymentDate = '';

  public ngOnChanges(): void {
    const details = this.submission?.destinationJurisdictions ?? [];
    const lumpSumDetails = details.filter(d => d.lumpSumPaymentAmount !== null);
    this.hasLumpSum = lumpSumDetails.length > 0;
    this.rows = lumpSumDetails.map(d => this.toRow(d));
    this.total = this.rows.reduce((sum, r) => sum + r.amount, 0);
    this.paymentDate = this.submission?.lumpSumPaymentDesiredPaymentDate ?? '';
  }

  private toRow(detail: VariableBenefitDestinationJurisdictionDetail): LumpSumRow {
    return {
      jurisdictionName: detail.governingJurisdiction?.name ?? $localize`Non-Locked-In`,
      amount: detail.lumpSumPaymentAmount ?? 0
    };
  }
}
